import {controlCenterActionTypes} from './controlCenter.actiontype';
export const actions = {
  request: () => ({ type: controlCenterActionTypes.REQUEST }),
  complete: () => ({ type: controlCenterActionTypes.COMPLETE }),
  requestAddFeature: () => ({ type: controlCenterActionTypes.REQUEST_ADD_FEATURE }),
  completeAddFeature: () => ({ type: controlCenterActionTypes.COMPLETE_ADD_FEATURE }),
  getControlCenterMalls: ({data}) => ({ type: controlCenterActionTypes.SUCCESS_FETCH_CONTROL_MALLS, data }),
  successControlCenterChecks: (data) => ({type: controlCenterActionTypes.SUCCESS_CONTROL_CENTER_CHECKS, data}),
  successAddMallFeatures: (data) => ({type: controlCenterActionTypes.SUCCESS_ADD_MALL_FEATURES, data})
};